import { render } from "./groupCreate.vue?vue&type=template&id=14a783d4&scoped=true"
import script from "./groupCreate.vue?vue&type=script&lang=js"
export * from "./groupCreate.vue?vue&type=script&lang=js"

import "./groupCreate.vue?vue&type=style&index=0&id=14a783d4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a783d4"]])

export default __exports__